import React from 'react';
import Button from '$/components/base/Button';
import { useCommonStore } from '@/store/useCommonStore';
import { useOfficialHomeContext } from '@/components/overseaHome/OfficialHomeContext';
import { OFFICIAL_HOME_LOCALIZED_CONTENT } from '@/components/overseaHome/localizedContent';
import {
  MOBILE_BG_IMAGE,
  PC_BG_IMAGE,
} from './media';
import style from './index.module.scss';

/** 渲染国内与海外官网共用首屏，并由浏览器断点选择对应静态背景。 */
export default function MainScreen() {
  const officialHome = useOfficialHomeContext();
  const toLogin = useCommonStore((state) => state.toLogin);
  // 官网上下文在 SSR 与水合阶段使用同一语言；兜底英文仅保护脱离页面容器的独立渲染。
  const heroContent = OFFICIAL_HOME_LOCALIZED_CONTENT[officialHome?.languageCode ?? 'en'].hero;

  /** 复用官网既有登录入口开始 IP 创作，并记录首屏 CTA 点击。 */
  const onStartIp = () => {
    window.mtstat?.track('roboneo_official_page_icon_click', {
      icon_id: 'create_your_ip',
    });
    toLogin();
  };

  return (
    <div className={style.main_screen}>
      <picture className={style.background_picture}>
        <source media="(max-width: 767px)" srcSet={MOBILE_BG_IMAGE} />
        <img
          aria-hidden="true"
          alt=""
          className={style.background_image}
          decoding="async"
          src={PC_BG_IMAGE}
        />
      </picture>
      <div className={style.background_mask} />
      <div className={style.center_box}>
        <h1 className={style.title}>
          {heroContent.titleLines.map((line) => (
            <span
              className={style.title_line}
              key={`${line.prefix ?? ''}${line.highlight ?? ''}${line.suffix ?? ''}`}
            >
              {line.prefix}
              {line.highlight && <span className={style.title_highlight}>{line.highlight}</span>}
              {line.suffix}
            </span>
          ))}
        </h1>
        <p className={style.description}>{heroContent.description}</p>
        <Button type="primary" className={style.start_button} onClick={onStartIp}>
          {heroContent.action}
        </Button>
      </div>

      <div className={style.linear_gradient_box} />
    </div>
  );
}
